import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'UPLOAD_QUITUS_FOURN',
  title: 'Come posso scaricare il File e i documenti del mio fornitore?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Il quitus è la sintesi della documentazione amministrativa del vostro fornitore presente sul OnceForAll.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Per scaricare il programma:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alla scheda «Fornitori»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_UPLOAD_QUITUS_FOURN/IT_UPLOAD_QUITUS_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Clicca sul pulsante «Scarica lo status del file»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_UPLOAD_QUITUS_FOURN/IT_UPLOAD_QUITUS_FOURN_2.png`
  }]
};
